export const getNameInitials = (name = ''): string =>
    name
        .trim()
        .split(/\s+/)
        .filter(Boolean)
        .map(part => part[0]?.toUpperCase())
        .filter(Boolean)
        .slice(0, 2)
        .join('');
